import { OwlMark } from "./Logo";

const items = ["Birthday Parties", "Baby Showers", "Wedding Showers", "Employee Lunches", "Anniversary Parties", "Graduation Celebrations", "Rehearsal Dinners", "Retirement Parties"];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-black/5 bg-bone2 py-5" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center">
          {items.map((item) => (
            <span key={`${half}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-10 font-serif text-2xl italic text-stone-700 sm:text-3xl">{item}</span>
              <OwlMark className="h-6 w-6 opacity-40" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
